<template>
  <el-dialog :append-to-body="true" title="选择物料" :visible="visible" width="1130px" @close="$emit('close')">
    <el-form ref="queryForm" inline class="search-form" label-width="80px">
      <el-form-item label="物料名称" prop="materialName">
        <el-input v-model.trim="queryParams.materialName" placeholder="请输入" clearable style="width: 160px">
        </el-input>
      </el-form-item>
      <el-form-item label="物料编码" prop="materialCode">
        <el-input v-model.trim="queryParams.materialCode" placeholder="请输入" clearable style="width: 160px">
        </el-input>
      </el-form-item>
      <el-form-item label="DI码" prop="diCode">
        <el-input v-model.trim="queryParams.diCode" placeholder="请输入" clearable style="width: 160px">
        </el-input>
      </el-form-item>
      <el-form-item label="批号" prop="batchNumber">
        <el-input v-model.trim="queryParams.batchNumber" placeholder="请输入" clearable style="width: 160px">
        </el-input>
      </el-form-item>
      <el-form-item label="仓库" prop="warehouseId">
        <el-select v-model="queryParams.warehouseId" style="width: 160px" placeholder="" clearable>
          <el-option v-for="item in wareHouseList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="handleSearch">搜索</el-button>
        <el-button size="mini" type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="tips">仅能选择已绑定DI且已生产的物料出库，若选择外箱物料出库，则对应的内层物料也需要绑定DI</div>

    <el-table
      ref="multipleTable"
      height="500"
      :data="udiDataList"
      style="width: 100%; margin-top: 12px"
      border
      stripe
      @sort-change="handleSortChange($event)"
      @selection-change="handleSelectionChange"
    >
    <el-table-column type="selection" width="55">
    </el-table-column>
      <el-table-column prop="diCode" label="DI码" width="150" show-overflow-tooltip/>
      <el-table-column prop="materialName" label="物料名称" width="150" show-overflow-tooltip/>
      <el-table-column prop="materialCode" label="物料编码" width="105" show-overflow-tooltip/>
      <el-table-column prop="specification" label="规格型号" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="batchNumber" label="批号" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="prodDate" label="生产日期" sortable="custom" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="expiryDate" label="失效日期" sortable="custom" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="warehouseName" label="仓库" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="packLevel" label="包装层级" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="number" label="库存数量" sortable="custom" min-width="120" show-overflow-tooltip/>
    </el-table>
    <pagination v-show="total > 0" style="margin-top: 24px" :total="total" :page-sizes="[10,50, 100, 300]"
                :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="handleOk"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {getInStockProduct} from '@/api/orderManage'
// import { getDict } from '@/api/common/index'
import {getWareHouse} from '@/api/warehouse'

export default {
  name: 'ProductSelect',
  props: {
    loading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => {
    return {
      total: 0,
      selectRows: [],
      udiDataList: [],
      wareHouseList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        minNumber: 1,
        diCode: null,
        batchNumber: null,
        materialCode: null,
        forbidStatus: "N",
        IsDi: 'Y',
        materialName: null,
        warehouseId: null,
        expiryDate: [],
        prodDate: [],
        isAsc: '',
        orderByColumn: 'T1.update_time'
      },
    }
  },
  mounted() {
    this.getList()
    this.getWareHouse()
  },
  methods: {
    // getDict(list) {
    //   list.forEach((dictType) => {
    //     getDict({ dictType }).then((res) => {
    //       this.dictsObj[dictType] = res.rows
    //     })
    //   })
    // },
    // 获取入库仓库
    getWareHouse() {
      getWareHouse().then((res) => {
        this.wareHouseList = res.rows
      })
    },
    handleSelectionChange(selection){
        this.selectRows = selection
    },
    handleOk() {
      if (!this.selectRows) {
        this.$message.error('请选择物料')
        return
      }
      this.selectRows.forEach((item) => {
        this.$emit('getData',item)
      })
      
    },
    // 搜索按钮点击
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    /**
     * @description: 重置筛选条件
     * @return {*}
     */
    reset() {
      this.queryParams = Object.assign(
        this.$data.queryParams,
        this.$options.data.call(this)
      ).queryParams
      this.getList()
    },
    // 获取列表数据
    getList() {
      // 获取生产任务列表数据
      this.$emit('update:loading', true) // 打开遮罩
      const queryParams = JSON.parse(JSON.stringify(this.queryParams))
      getInStockProduct(queryParams)
        .then((res) => {
          this.udiDataList = res.rows
          this.total = res.total
        })
        .finally(() => {
          this.$emit('update:loading', false) // 关闭遮罩
        })
    },
    handleSortChange(sort) {
      const {order} = sort
      switch (sort.prop) {
        case 'number':
          this.queryParams.orderByColumn = 'T1.number'
          break
        case 'prodDate':
          this.queryParams.orderByColumn = 'T1.prod_date'
          break
        case 'expiryDate':
          this.queryParams.orderByColumn = 'T1.expiry_date'
          break
        default:
          this.queryParams.orderByColumn = 'T1.update_time'

      }
      if (order === 'descending') {
        this.queryParams.isAsc = 'desc'
      }else if (order === null){
        this.queryParams.isAsc = null
        this.queryParams.orderByColumn = 'T1.update_time'
      } else {
        this.queryParams.isAsc = 'asc'
      }

      this.handleSearch()
    }
  }
}
</script>

<style scoped>
.tips {
  margin-bottom: 12px;
  font-size: 14px;
  color: #fa8c16;
}
</style>
